import {
  DEFAULT_ORDER_BY_INGESTION_ACCOUNTS,
  DEFAULT_SORT_BY_INGESTION_ACCOUNTS
} from "../../utils/constants/reducerConstants";
import { createSlice } from "@reduxjs/toolkit";

import {
  IIngestionAccountsCardDetails,
  IIngestionAccountsTableResponse
} from "interfaces/ingestionAccounts.interface";
import { getInitialAccountCardContent } from "../../utils/HelperFunctions";

interface IngestionAccountsInterface {
  ingestionAccountsCardContent: IIngestionAccountsCardDetails[];
  searchKeyWord: string;
  tableResponse: IIngestionAccountsTableResponse;
  orderBy: string;
  sortByColumn: string;
  selectedPage: number;
  isActive: string;
  linkedin_username: string | null;
  tableRowIsActive: string;
  selectedAccountId: string;
  checkedAccountIds: string[];
  accountUsersSelectedCount: number;
  domainAndUserPresent: boolean;
  accountMembersMap: Record<string, number>; // Map of account ID to total_active_members
}

const initialState: IngestionAccountsInterface = {
  ingestionAccountsCardContent: getInitialAccountCardContent(),
  searchKeyWord: "",
  orderBy: DEFAULT_ORDER_BY_INGESTION_ACCOUNTS,
  sortByColumn: DEFAULT_SORT_BY_INGESTION_ACCOUNTS,
  selectedPage: 1,
  tableResponse: {
    error: null,
    response: {
      page_no: 0,
      total: 0,
      data: []
    }
  },
  isActive: "",
  selectedAccountId: "",
  linkedin_username: null,
  tableRowIsActive: "",
  checkedAccountIds: [],
  accountUsersSelectedCount: 0,
  domainAndUserPresent: false,
  accountMembersMap: {}
};

const ingestionAccountsSlice = createSlice({
  name: "ingestionAccounts",
  initialState,
  reducers: {
    setSearchKeyWord: (state, action) => {
      state.searchKeyWord = action.payload;
    },
    setIngestionAccountsCardContent: (state, action) => {
      state.ingestionAccountsCardContent = action.payload;
    },
    setTableResponse: (state, action) => {
      state.tableResponse = action.payload;
    },
    setOrderBy: (state, action) => {
      state.orderBy = action.payload;
    },
    setSortByColumn: (state, action) => {
      state.sortByColumn = action.payload;
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    setInitIngestionAccounts: () => {
      return initialState;
    },
    setIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    setAccountLinkedInUsername: (state, action) => {
      state.linkedin_username = action.payload;
    },
    setTableRowIsActive: (state, action) => {
      state.tableRowIsActive = action.payload;
    },
    setSelectedAccountId: (state, action) => {
      state.selectedAccountId = action.payload;
    },
    setCheckedAccountIds: (state, action) => {
      state.checkedAccountIds = action.payload;
    },
    setAccountUsersSelectedCount: (state, action) => {
      state.accountUsersSelectedCount = action.payload;
    },
    setDomainAndUserPresent: (state, action) => {
      state.domainAndUserPresent = action.payload;
    },
    setAccountMembersMap: (state, action) => {
      state.accountMembersMap = {
        ...state.accountMembersMap,
        ...action.payload
      };
    },
    clearAccountMembersMap: (state) => {
      state.accountMembersMap = {};
    }
  }
});

export const {
  setSearchKeyWord,
  setIngestionAccountsCardContent,
  setOrderBy,
  setSelectedPage,
  setSortByColumn,
  setTableResponse,
  setInitIngestionAccounts,
  setIsActive,
  setAccountLinkedInUsername,
  setTableRowIsActive,
  setSelectedAccountId,
  setCheckedAccountIds,
  setAccountUsersSelectedCount,
  setDomainAndUserPresent,
  setAccountMembersMap,
  clearAccountMembersMap
} = ingestionAccountsSlice.actions;

export default ingestionAccountsSlice.reducer;
